module.exports = __webpack_public_path__ + "static/identify-badd1f0515a0925ee3f34016d1b3eb8f.png";